/* Kanpla: side panel and hover behaviour for the product hotspots section.

   Two things happen here.

   1. A panel is built beside the photo: always populated, switching as you
      hover or click a hotspot, with pagination dots underneath. It reads what
      Dwell has already rendered (the product image, title, price and the
      vendor attribute added in blocks/_hotspot-product.liquid) rather than
      fetching anything, so there is no extra request and no second source of
      truth. If that markup ever changes shape the panel is simply not built
      and the section falls back to Dwell's own behaviour.

   2. Dwell opens its hotspot popover on click only. Hovering a hotspot now
      opens it too, by dispatching a click on Dwell's own trigger so their
      positioning logic does the work, and closes it again on leave. The
      popover sits inside the hotspot element, so moving the pointer from the
      dot onto the card does not count as leaving. Pointer-capable devices
      only, so touch is unaffected.

   Layout and appearance live in assets/kanpla-buttons.css. */
(function () {
  var SECTION = '.section-product-hotspots';
  var canHover =
    typeof window.matchMedia === 'function' && window.matchMedia('(hover: hover)').matches;

  function buildCard(hotspot, index) {
    var dialog = hotspot.querySelector('.hotspot-dialog');
    if (!dialog) return null;

    var url = hotspot.getAttribute('data-product-url') || '';
    var title = hotspot.getAttribute('data-product-title') || '';
    var vendor = hotspot.getAttribute('data-product-vendor') || '';
    var image = dialog.querySelector('.hotspot-dialog__product-image');
    var price = dialog.querySelector('.hotspot-dialog__product-price');

    if (!title) {
      var titleEl = dialog.querySelector('.hotspot-dialog__product-title');
      title = titleEl ? titleEl.textContent.trim() : '';
    }
    if (!title) return null;

    var card = document.createElement(url ? 'a' : 'div');
    card.className = 'kanpla-hs-card';
    if (url) card.setAttribute('href', url);
    card.setAttribute('data-index', String(index));

    var media = document.createElement('div');
    media.className = 'kanpla-hs-card__media';
    if (image) {
      var img = image.cloneNode(true);
      img.className = 'kanpla-hs-card__img';
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.setAttribute('loading', 'lazy');
      media.appendChild(img);
    }
    card.appendChild(media);

    var info = document.createElement('div');
    info.className = 'kanpla-hs-card__info';

    if (vendor) {
      var v = document.createElement('span');
      v.className = 'kanpla-hs-card__vendor';
      v.textContent = vendor;
      info.appendChild(v);
    }

    var row = document.createElement('div');
    row.className = 'kanpla-hs-card__row';

    var t = document.createElement('span');
    t.className = 'kanpla-hs-card__title';
    t.textContent = title;
    row.appendChild(t);

    if (price) {
      var p = document.createElement('span');
      p.className = 'kanpla-hs-card__price';
      p.innerHTML = price.innerHTML;
      row.appendChild(p);
    }

    info.appendChild(row);
    card.appendChild(info);
    return card;
  }

  function init(section) {
    if (section.getAttribute('data-kanpla-panel')) return;

    var wrapper = section.querySelector('.section-product-hotspots__wrapper');
    var hotspots = Array.prototype.slice.call(
      section.querySelectorAll('product-hotspot-component.hotspot')
    );
    if (!wrapper || hotspots.length === 0) return;

    var panel = document.createElement('div');
    panel.className = 'kanpla-hs-panel';

    var stack = document.createElement('div');
    stack.className = 'kanpla-hs-stack';

    var cards = [];
    var used = [];
    hotspots.forEach(function (hotspot) {
      var card = buildCard(hotspot, cards.length);
      if (!card) return;
      stack.appendChild(card);
      cards.push(card);
      used.push(hotspot);
    });

    if (cards.length === 0) return;

    section.setAttribute('data-kanpla-panel', 'ready');
    panel.appendChild(stack);

    var dotButtons = [];
    if (cards.length > 1) {
      var dots = document.createElement('div');
      dots.className = 'kanpla-hs-dots';
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'kanpla-hs-dot';
        dot.setAttribute('aria-label', 'Show product ' + (i + 1) + ' of ' + cards.length);
        dot.addEventListener('click', function (event) {
          event.preventDefault();
          select(i);
        });
        dots.appendChild(dot);
        dotButtons.push(dot);
      });
      panel.appendChild(dots);
    }

    wrapper.appendChild(panel);

    var active = -1;
    function select(index) {
      if (index === active || index < 0 || index >= cards.length) return;
      active = index;
      cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === index);
        card.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dotButtons.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      used.forEach(function (hotspot, i) {
        hotspot.classList.toggle('kanpla-hs-current', i === index);
      });
    }

    used.forEach(function (hotspot, i) {
      var trigger = hotspot.querySelector('.hotspot-trigger');
      var dialog = hotspot.querySelector('.hotspot-dialog');

      if (trigger) {
        trigger.addEventListener('click', function () {
          select(i);
        });
        trigger.addEventListener('focus', function () {
          select(i);
        });
      }

      hotspot.addEventListener('mouseenter', function () {
        select(i);
        if (!canHover || !dialog || !trigger || dialog.open) return;
        // Dwell opens and positions the popover from this click
        trigger.click();
      });

      hotspot.addEventListener('mouseleave', function () {
        if (!canHover || !dialog || !dialog.open) return;
        try {
          dialog.close();
        } catch (e) {
          /* a dialog mid-transition can throw, nothing to do */
        }
      });
    });

    select(0);
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll(SECTION)).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
